import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "app"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
  const _component_van_tabbar = _resolveComponent("van-tabbar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createBlock(_component_router_view, {
    key: this.$route.path
  })), _createVNode(_component_van_tabbar, {
    modelValue: $setup.active,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.active = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
      icon: "home-o",
      to: "/index"
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("电费充值管理")])),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      icon: "home-o",
      to: "/huafei"
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("话费充值管理")])),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      icon: "search",
      to: "/order"
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("订单管理")])),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]);
}